import { apiRoutes } from "@constants/api-routes";
import { RequestTypes } from "@enums/request-types";
import { handleRequest } from "@utils/http-util";
import { AxnAdminUserInvitation } from "@idw-types/data/axn-admin-user-invitation";

type GetAxnAdminUserInvitationsRequestResponse = {
    axnAdminUserInvitations: Array<AxnAdminUserInvitation>;
};

export const getAxnAdminUserInvitationsRequest = async (): Promise<{ data: GetAxnAdminUserInvitationsRequestResponse, error: any }> => {
    const route = apiRoutes.axnadminCore.data.axnadminuserinvitation;
    const { data, error } = await handleRequest(RequestTypes.GET, route);
    return { data, error };
};